<template>
  <div>

    <b-card-actions action-collapse title=" Container">
      <div>
        <div class="btn-delete-all text-right">
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all mr-1"  @click="saveContainer()">
            <feather-icon icon="SaveIcon" />
          </b-button>

          <b-button variant="gradient-primary" class="btn-icon mr-1" @click="downloadXLSX">
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table @on-select-file="uploadXLSX" class="btn-icon-upload">
            Upload
            <feather-icon icon="UploadIcon" />
          </vue-xlsx-table>
        </div>
        
        <div>
          <b-row
            class="mt-1"
            v-for="(item, i) in containerTab"
            :id="item.id"
            :key="i"
          >
            <b-col b-col cols="12" lg="4" md="3" sm="12">
              <b-form-group label="Ref" label-for="Ref">
                <b-form-input
                  placeholder="Ref"
                  v-model="item.title"
                  required
                  id="title"
                />
              </b-form-group>
            </b-col>

              <b-col b-col cols="12" lg="4" md="3" sm="12">
              <b-form-group label="Type" label-for="type">
                <b-form-input
                  placeholder="Type/Size"
                  v-model="item.sizeType"
                  required
                  id="type"
                />
              </b-form-group>
            </b-col>
<!-- 
            <b-col b-col cols="12" lg="3" md="2" sm="12">
              <b-form-group label="Type" label-for="type">
                <b-form-input
                  placeholder="Type"
                  v-model="item.type"
                  required
                  id="type"
                />
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="2" md="2" sm="12">
              <b-form-group label="Size" label-for="size">
                <b-form-input
                  placeholder="Size"
                  v-model="item.size"
                  required
                  id="size"
                />
              </b-form-group>
            </b-col> -->

            <b-col b-col cols="12" lg="2" md="2" sm="12">
              <b-form-group label="Tare" label-for="tare">
                <b-form-input
                  placeholder="Tare"
                  v-model="item.tare"
                  required
                  id="tare"
                />
              </b-form-group>
            </b-col>
            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="repeateAgainContainer(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeContainer(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <b-col b-col cols="12" lg="3" md="3" sm="12">
              <b-form-group>
                <b-form-checkbox v-model="item.frigorifique" true-value="true" false-value="false"
                >Frigorifique</b-form-checkbox
                >
              </b-form-group>
            </b-col>
             <b-col b-col cols="12" lg="3" md="3" sm="12">
              <b-form-group>
                <b-form-checkbox v-model="item.openTop" true-value="true" false-value="false"
                >Open top</b-form-checkbox
                >
              </b-form-group>
            </b-col>
             <b-col b-col cols="12" lg="3" md="3" sm="12">
              <b-form-group>
                <b-form-checkbox v-model="item.flatRack" true-value="true" false-value="false"
                >Flat rack</b-form-checkbox
                >
              </b-form-group>
            </b-col>
             <b-col b-col cols="12" lg="3" md="3" sm="12">
              <b-form-group>
                <b-form-checkbox v-model="item.soc" true-value="true" false-value="false"
                >SOC</b-form-checkbox
                >
              </b-form-group>
            </b-col>
            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>

    <!-- <b-card-actions action-collapse title=" Date">

 </b-card-actions> -->
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormCheckbox
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import * as XLSX from 'xlsx';

export default {
  components: {
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
    vSelect,
    BFormCheckbox,
    XLSX
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      // json_data: [],
      // json_fields: {
      //   society: "society",
      //   Nom: "firstName",
      //   Prenom: "lastName",
      //   Email: "email",
      //   Cite: "city",
      //   numero: "telNumbers",
      //   "Matricule Fiscale": "registrationNumber",
      // },
      containerTab: [
        {
          id: 1,
          title: "",
          type: "",
          size: "",
          sizeType: "",
          tare: "",
          frigorifique: false,
          openTop: false,
          flatRack: false,
          soc: false,
          _id:""
        },
      ],
      nextTodoId: 2,
      containerItems:{},
      routesToSend:[]
    };
  },
  mounted() {
    //this.initTrHeight()
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.getDataManagement()
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    async getDataManagement(){
      this.containerTab=[]
      // container
        axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/containers"
        )
        .then((response) => {
          response.data.data.forEach((element,index) => {
            this.containerTab.push({
              id: index,
              title: element.title,
              type: element.type,
              size: element.size,
              sizeType: element.sizeType,
              tare: element.tare,
              frigorifique: element.frigorifique,
              openTop: element.openTop,
              flatRack: element.flatRack,
              soc: element.soc,
              _id:element._id
            })
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });

    },
    
    saveContainer() {
      const filteredData = this.containerTab.filter(container => container.title !== '' || container.sizeType !== '');
      const isEmpty = filteredData.some((item) => item.title === "" || item.sizeType === "");
      if (isEmpty) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please fill the form",
            icon: "EditIcon",
            variant: "warning",
          },
        });       
      }
      else {
        axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/containers", filteredData
        )
        .then((response) => {
           this.$toast({
            component: ToastificationContent,
            props: {
              title: "Container updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
      }
    },
   

    repeateAgainContainer() {
      this.containerTab.push({
        id: this.containerTab.length,
        title: "",
        type: "",
        size: "",
        sizeType: "",
        tare: "",
        frigorifique: false,
         openTop: false,
          flatRack: false,
          soc: false,
      });
    },
    removeContainer(i) {
      this.containerTab.splice(i, 1);
    },
    downloadXLSX() {
      const data = [];
      this.containerTab.forEach((container) => {
        data.push({
          "Container" : container.title,
          // "Type" : container.type,
          // "Size" : container.size,
          "sizeType": container.sizeType,
          "Tare" : container.tare,
          "Frigorifique" : container.frigorifique,
           "openTop":  container.openTop,
          "flatRack": container.flatRack,
          "soc":  container.soc,
        })
      })
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Containers');
      XLSX.writeFile(workbook, 'GuidelineContainer.xlsx');
    },
    uploadXLSX(convertedData) {
      const data = [];
      let lastId = this.containerTab[this.containerTab.length - 1].id;
      convertedData.body.forEach((element) => {
        lastId++ 
        data.push({
          id : lastId,
          title : element["Container"],
          // type : element["Type"],
          // size : element["Size"], 
          sizeType: element["sizeType"],
          tare : element["Tare"],  
          frigorifique: element["Frigorifique"].toUpperCase() === "TRUE" ? true : false, 
          openTop: element["openTop"].toUpperCase() === "TRUE" ? true : false, 
          flatRack: element["flatRack"].toUpperCase() === "TRUE" ? true : false, 
          soc: element["soc"].toUpperCase() === "TRUE" ? true : false, 
        })
      })
      this.containerTab = this.containerTab.concat(data)
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
.btn-add {
  margin-top: 20px;
}
.btn-icon-upload button{
  background-image: linear-gradient(47deg, #010022, #030055)!important;
  padding: 0.715rem 0.736rem;
  text-align: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.358rem;
  font-weight: 500;
  font-size: 1rem;
}
</style>